import z from 'zod';

export const addEventStyleSchema = z.object({
  styleId: z.string().min(1, 'Style is required'),
});
